// extracted by mini-css-extract-plugin
export default {"base":"SearchCriteria_base__vY4Yo","remove":"SearchCriteria_remove__f71ps"};